/* Workflows Client barrel export */

import { IWorkflowsClient } from './IWorkflowsClient';
import { WorkflowsClientApi } from './workflowsClientApi';
import { WorkflowsClientMocked } from './workflowsClientMocked';

// Re-export types
export * from './workflowsTypes';
export * from './IWorkflowsClient';

/* ---- Configuration ---- */

import { shouldUseMockedClient } from '../../environment';

/**
 * Determines whether to use mocked clients.
 * Automatically uses mocked clients on localhost and ofstest5 environments.
 */
const isMockedEnvironment = () => shouldUseMockedClient();

/* ---- Factory Function ---- */

let clientInstance: IWorkflowsClient | null = null;

/**
 * Get the WorkflowsClient instance.
 * Automatically uses mocked data on localhost and ofstest5 environments.
 */
export function getWorkflowsClient(): IWorkflowsClient {
  if (clientInstance) {
    return clientInstance;
  }

  if (isMockedEnvironment()) {
    clientInstance = new WorkflowsClientMocked();
  } else {
    clientInstance = new WorkflowsClientApi();
  }
  return clientInstance;
}

/**
 * Reset the client instance (useful for testing).
 */
export function resetWorkflowsClient(): void {
  clientInstance = null;
}

/* ---- Backwards Compatibility ---- */

/**
 * @deprecated Use getWorkflowsClient() instead
 */
export class WorkflowsClient extends WorkflowsClientMocked {}
